module.exports = __webpack_public_path__ + "img/logo_Zurich.73001d3e.svg";